import React from 'react';

import * as S from './styles';

const Slide1: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Credits>
        Diretor de criação: Luciano Schmitz | Foto: Ivan Erick
        <br />
        Edição de moda: Lucas Boccalão | Beleza: Daniel Hernandez com produtos
        Dior
      </S.Credits>
    </S.Container>
  );
};

export { Slide1 };
